// Display label maps + brand style helpers

export const QUAL_LABELS = {
  dod_contracts: {
    label: "Has or pursues DoD contracts?",
    options: { yes: "Yes, holds DoD contracts", pursuing: "Pursuing / bidding", no: "No" },
  },
  asked_about_requirements: {
    label: "Asked about CMMC / NIST 800-171 / SPRS / CUI?",
    options: { yes: "Yes", no: "No" },
  },
  handles_cui: {
    label: "Handles, stores, or transmits CUI?",
    options: { yes: "Yes", expect: "Expects to", no: "No" },
  },
  ssp_poam: {
    label: "Has an SSP and POA&M?",
    options: { both: "Has both", ssp_only: "SSP only", poam_only: "POA&M only", neither: "Neither", unknown: "Unknown" },
  },
  self_assessment: {
    label: "Completed NIST 800-171 self-assessment / SPRS score?",
    options: { yes_sprs: "Yes, entered in SPRS", self_only: "Self-assessed only", no: "No" },
  },
  timeline: {
    label: "Timeline",
    options: { immediate: "Immediate / has deadline", "3_months": "Within 3 months", "6_months": "Within 6 months", "12_months": "Within 12 months", none: "No timeline" },
  },
  decision_maker_access: {
    label: "Decision-maker access?",
    options: { yes: "Yes", no: "No" },
  },
};

export const ENV_OPTIONS = [
  "Microsoft 365 Commercial",
  "Microsoft 365 GCC",
  "Microsoft 365 GCC High",
  "GCC High migration in progress",
  "Google Workspace",
  "On-prem file server",
  "Hybrid on-prem and cloud",
  "AWS GovCloud",
  "Other",
];

export const BUCKET_STYLES = {
  "Hot Opportunity": "bg-red-100 text-red-800 border-red-200",
  "Qualified Lead": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Education Lead": "bg-blue-100 text-blue-800 border-blue-200",
  "Low Fit": "bg-slate-100 text-slate-600 border-slate-200",
  "Proposal Ready": "bg-gold/20 text-gold-dark border-gold/40",
  "Proposal Sent": "bg-violet-100 text-violet-800 border-violet-200",
};

export const URGENCY_STYLES = {
  High: "bg-red-100 text-red-700 border-red-200",
  Medium: "bg-amber-100 text-amber-800 border-amber-200",
  Low: "bg-slate-100 text-slate-600 border-slate-200",
};

export const STAGE_STYLES = {
  "Closed Won": "bg-emerald-600 text-white",
  "Closed Lost / Nurture": "bg-slate-400 text-white",
  "Proposal Sent": "bg-violet-600 text-white",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}
